var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz48",
    d: "M7.25,21A1.282,1.282,0,0,1,6,19.75V7.25A1.282,1.282,0,0,1,7.25,6h6.063V7.25H7.25v12.5h6.063V21Zm10.125-3.854-.9-.9L18.6,14.125H11.313v-1.25h7.25L16.438,10.75l.9-.9L21,13.521Z",
    transform: "translate(-6 -6)",
    fill: "#575757"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.0adc4fde94de720b2b609dd3ec1725d2.svg";
export { ForwardRef as ReactComponent };